import { ContainerModule, interfaces } from "inversify";
import { IocTypes } from "../ioc.types";
import IRepository from 'data/IRepository';
import Repository from 'data/Repository';
import IDataService from "data/IDataService";
import DataService from "data/DataService";
import IFileService from "data/IFileService";
import FileService from "data/FileService";
import IDataHelper from 'data/IDataHelper';
import DataHelper from 'data/DataHelper';

export const dataModule = new ContainerModule((bind: interfaces.Bind) => {
  bind<IRepository<any>>(IocTypes.Repository).to(Repository);
  bind<IDataService>(IocTypes.DataService).to(DataService);
  bind<IFileService>(IocTypes.FileService).to(FileService);
  bind<IDataHelper>(IocTypes.DataHelper).to(DataHelper).inSingletonScope();
});